export default __webpack_public_path__ + "static/media/email.c733ac88.svg";